@for (facet of facets(); track facet.fieldName) {
  @if (facet.items?.length) {
    @if (activeTab()?.entityType; as entityType) {
      <procure-search-facet
        [facet]="facet"
        [control]="facetsForms.controls[entityType | uppercase].controls[facet.fieldName]"
      />
    }
  }
}
